import { render, staticRenderFns } from "./TaobaoPurchaseOrderAddress.vue?vue&type=template&id=7e50b0d9&scoped=true"
import script from "./TaobaoPurchaseOrderAddress.vue?vue&type=script&lang=js"
export * from "./TaobaoPurchaseOrderAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e50b0d9",
  null
  
)

export default component.exports